import React, { useState, useLayoutEffect, useRef } from "react";

//styles
import styled from "styled-components";
import SV from "../../styles/variables";

//components
import CustomSelect from "../../components/select";
import {
  H2,
  Container,
  HeaderRow,
  Overflow
} from "../../components/layout/box";

//models

import { TooltipObj } from "../../models/tooltip";
import Tooltip from "../../components/tooltip";

//data-vis
import {
  XYPlot,
  XAxis,
  YAxis,
  LineSeries,
  LineSeriesPoint,
  LineMarkSeries,
  LineMarkSeriesPoint,
  VerticalBarSeriesPoint,
  CustomSVGSeries,
  CustomSVGSeriesPoint,
  ChartLabel
} from "react-vis";

//helpers
import {
  getRelativePosition,
  getSelectedBrands,
  MockDataDate
} from "./helpers";

import { SizeMe } from "react-sizeme";

const width = 656;
const padding = 40;
const height = 416;
const minSize = 480;

const ViewsByBrand = () => {
  const [tooltip, setStateToolTip] = useState<TooltipObj>({
    open: false,
    x: 0,
    y: 0
  });

  const GridRef = useRef<any>();

  return (
    <SizeMe monitorWidth={true}>
      {({ size }) => {
        if (size && size.width)
          return (
            <Overflow minSize={minSize}>
              <Container width={size.width} padding={padding}>
                <HeaderRow>
                  <H2> Date and number of views </H2>
                  <div style={{ display: "inline-block", height: "25px" }} />
                </HeaderRow>
                <div ref={GridRef}>
                  <XYPlot
                    width={Math.max(size.width, minSize) - padding * 2}
                    height={size.width * 0.66}
                    xType="time"
                    margin={{ left: 70 }}
                    yDomain={[0, 10000]}
                    xDomain={[
                      new Date("01/01/2018").getTime(),
                      new Date("01/09/2018").getTime()
                    ]}
                  >
                    <YAxis />
                    <ChartLabel
                      text="Number of views"
                      xPercent={0.02}
                      yPercent={0.4}
                      className="YAxis"
                      style={{
                        transform: "rotate(-90)",
                        textAnchor: "start",
                        height: "20px",
                        font: "25px"
                      }}
                    />
                    <LineSeries
                      data={MockDataDate as LineSeriesPoint[]}
                      strokeWidth={1}
                    />
                    <CustomSVGSeries
                      data={(MockDataDate as unknown) as CustomSVGSeriesPoint[]}
                      customComponent={(row: any, positionInPixels: any) => {
                        return (
                          <g className="square-component">
                            <rect
                              className="square-shadow"
                              height="16"
                              width="16"
                              rx="4"
                              ry="4"
                              fill="white"
                              transform="translate(-8,-8)"
                            />
                            <rect
                              className="square-blue"
                              height="8"
                              width="8"
                              rx="2"
                              ry="2"
                              stroke="#6d9cf9"
                              fill="#fff"
                              transform="translate(-4,-4)"
                            />
                          </g>
                        );
                      }}
                      onValueMouseOver={(datapoint, event: any) => {
                        if (GridRef && GridRef.current) {
                          const { x, y } = getRelativePosition(
                            event.event.target,
                            GridRef.current as HTMLElement,
                            "line"
                          );
                          setStateToolTip({
                            x,
                            y,
                            open: true,
                            views: datapoint.y
                          });
                        }
                      }}
                      onValueMouseOut={() => {
                        setStateToolTip({
                          open: false
                        });
                      }}
                    />
                    <XAxis
                      className="LineXAxis"
                      tickTotal={Math.min(MockDataDate.length, 7)}
                    />
                    <Tooltip
                      open={tooltip.open}
                      x={tooltip.x}
                      y={tooltip.y}
                      views={tooltip.views}
                    />
                  </XYPlot>
                </div>
              </Container>
            </Overflow>
          );
        else return <div />;
      }}
    </SizeMe>
  );
};

export default ViewsByBrand;
